



























































import { Component, Mixins } from "vue-property-decorator";
import { NewLine } from "@/store/modules/ui";
import { mapState } from "vuex";
import { IState } from "@/store";

import HasValidation from "@/mixins/HasValidation";
import { UserMetaKeys } from "@/data/enums/users";

@Component({
  computed: {
    ...mapState({
      storeNewLine: (state: IState) => state.ui.support.newLine,
      storeSubmitWithShortcut: (state: IState) =>
        state.ui.support.submitWithShortcut
    })
  }
})
export default class TicketSettingsModal extends Mixins(HasValidation) {
  // Data

  public storeNewLine!: NewLine;
  public storeSubmitWithShortcut!: boolean;
  public newLine = NewLine.ENTER;
  public submitWithShortcut = true;

  // Lifecycle methods

  public created() {
    this.newLine = this.storeNewLine;
    this.submitWithShortcut = this.storeSubmitWithShortcut;
  }

  // Computed

  public get newLineOptions() {
    return [
      {
        leftLabel: this.$t("_sentence.support.new_line_enter_setting"),
        value: NewLine.ENTER
      },
      {
        leftLabel: this.$t("_sentence.support.new_line_shift_enter_setting"),
        value: NewLine.SHIFT_AND_ENTER
      }
    ];
  }

  public get isNewLineOnEnter() {
    return this.newLine === NewLine.ENTER;
  }

  // Methods

  public savePreferences() {
    this.$store.dispatch("user/addMeta", {
      [UserMetaKeys.UI_SUPPORT_NEW_LINE]: this.newLine,
      [UserMetaKeys.UI_SUPPORT_SUBMIT_WITH_SHORTCUT]: this.submitWithShortcut
    });
    this.$emit("close");
  }
}
